import { atom } from 'recoil'

export const selectedCostTransactionHistoryDateState = atom<{
    startDate: Date | null; endDate: Date | null;
}>({
    key: 'costTransactionHistoryDate',
    default: {
        startDate: null,
        endDate: null,
    },
})

